type SpinnerSize = 'small' | 'medium' | 'large'

type Props = {
  size?: SpinnerSize
}

export default function Spinner({ size = 'medium' }: Props) {
  return <div className={`spinner spinner-${size}`}></div>
}
